import { Href } from '@weenat/client/dist/routx/runtime-core'
import { useNavigate } from 'app/routx-router'
import isNil from 'lodash-es/isNil'
import Button, { ButtonProps } from './Button'
import Icons from './Icons'

export interface ButtonCreateProps extends ButtonProps {
  to?: Href
}

const ButtonCreate: FC<ButtonCreateProps> = ({ children, to, isDisabled, IconLeft, ...props }) => {
  const nav = useNavigate()

  return (
    <Button
      IconLeft={IconLeft ?? Icons.PlusSignCircle}
      onPress={() => {
        if (!isDisabled && !isNil(to)) nav(to)
      }}
      isDisabled={isDisabled}
      {...props}
    >
      {children}
    </Button>
  )
}

export default ButtonCreate
